import React from 'react';

import { URL_PARAMS } from '../../../../../../../constants';
import { PerformancesTableButton } from '../../../../../../nav';
import { DeltaDisplay } from './DeltaDisplay';

interface WorkInfoProps {
    /**
     * A delta of earnings between two statements
     */
    earningsDelta: Maybe<number>;
    /**
     * A delta of earnings between two statements, as a percentage. Since the user can't tell the
     * difference between a 100% delta and a track that was only in one statement, this is null if
     * the track is missing from one of the statements.
     */
    earningsPercentDelta: Maybe<number>;
    /**
     * A label that describes the track's significance
     */
    label: string;
    /**
     * The title of the track
     */
    trackTitle: Maybe<string>;
}

/**
 * Shows a label and track title for a given work.
 * @param {WorkInfoProps} props
 */
export const WorkInfo = ({
    earningsDelta,
    earningsPercentDelta,
    label,
    trackTitle,
}: WorkInfoProps): JSX.Element | null => {
    if (trackTitle === null || earningsDelta === null) {
        return null;
    }

    return (
        <div className="mt-3 grid grid-cols-2">
            <div>
                <div className="text-sm">{label}</div>
                {trackTitle.length > 0 && (
                    <PerformancesTableButton
                        urlSearchParams={[
                            { key: URL_PARAMS.WORK_TITLE, value: trackTitle },
                        ]}
                        statementSelectionLogic={{
                            type: 'presetsWithRegion',
                            presetsWithRegion: {
                                primary: 'all_domestic',
                                fallback: 'all_international',
                            },
                        }}
                    >
                        <div className="underline text-left font-semibold clamp-2-lines-break-words leading-5">
                            {trackTitle}
                        </div>
                    </PerformancesTableButton>
                )}
            </div>
            <div className="flex items-center justify-end">
                <DeltaDisplay
                    displayMode="grid"
                    earningsPercentDelta={earningsPercentDelta}
                    earningsDelta={earningsDelta}
                    size="sm"
                />
            </div>
        </div>
    );
};
